import { all, put, takeEvery } from "@redux-saga/core/effects";
import { setErrorStatus } from "../status/action";
import { getProcedureHistoryTotalCount } from "../../Services/database";
import { isValidArray } from "../../Services/validators";
import { getFileUrl } from "../../Services/storage";
import store from "../store";

export const actionTypes = {
  PUT_PROCEDURE_HISTORY_DATA: "PUT_PROCEDURE_HISTORY_DATA",
  GET_PROCEDURE_HISTORY_ASSETS: "GET_PROCEDURE_HISTORY_ASSETS"
};

function* putProceduresHistoryWorker(action) {
  try {
    const count = yield getProcedureHistoryTotalCount({
      filters: action.payload.filters
    });

    yield put({
      type: "SET_PROCEDURE_HISTORY_DATA",
      payload: { data: action.payload.data }
    });

    yield put({
      type: "SET_PROCEDURE_HISTORY_COUNT",
      payload: {
        count: count
      }
    });
  } catch (error) {
    yield setProcedureHistoryLoading(false);
    setErrorStatus(error);
  }
}

function* setProcedureHistoryAssetsWorker(action) {
  try {
    yield setProceduresHistoryAssetLoading(true);

    const selectedProcedureHistory = store.getState().table.procedureHistory
      .selectedProcedureHistory;
    if (
      action.payload.data.documentId === selectedProcedureHistory.documentId
    ) {
      const updates = action.payload.data.latestUpdate;

      for (let i = 0; i < updates.length; i++) {
        const proof = updates[i].proof || [];
        let images = [];
        let fileSrc = {};

        if (isValidArray(proof)) {
          for (let j = 0; j < proof.length; j++) {
            const file = yield getFileUrl(proof[j]);
            if (file.type === "image") {
              images.push(file.url);
            } else if (file.type === "audio") {
              fileSrc = { ...fileSrc, audio: file.url };
            }
          }
        }

        updates[i] = {
          ...updates[i],
          fileSrc: {
            ...fileSrc,
            ...(isValidArray(images) ? { images } : {})
          }
        };
      }

      const procedureHistory = store.getState().procedureHistory.data;
      yield put({
        type: "SET_PROCEDURE_HISTORY_DATA",
        payload: {
          data: {
            ...procedureHistory,
            [action.payload.data.documentId]: {
              ...procedureHistory[action.payload.data.documentId],
              latestUpdate: updates
            }
          }
        }
      });
    }
    yield setProceduresHistoryAssetLoading(false);
  } catch (error) {
    yield setProceduresHistoryAssetLoading(false);

    setErrorStatus(error);
  }
}

export default function* procedureHistoryWatcher() {
  yield all([
    takeEvery("PUT_PROCEDURE_HISTORY_DATA", putProceduresHistoryWorker),
    takeEvery("GET_PROCEDURE_HISTORY_ASSETS", setProcedureHistoryAssetsWorker)
  ]);
}

function* setProcedureHistoryLoading(bool) {
  yield put({
    type: "SET_PROCEDURE_HISTORY_LOADING",
    payload: {
      loading: bool
    }
  });
}
function* setProceduresHistoryAssetLoading(bool) {
  yield put({
    type: "SET_PROCEDURE_HISTORY_ASSETS_LOADING",
    payload: {
      loading: bool
    }
  });
}
